import React from "react";

export function SvgArrowsIcon() {
  return <svg viewBox="0 0 81 39">
    <g fillRule="nonzero">
      <path d="m64.5 16.5 14-7-14-7v6h-63v2h63v6zM16.5 22.5l-14 7 14 7v-6h63v-2h-63v-6z"/>
    </g>
  </svg>;
}